import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';

import { RFormInputItem } from '@t7x000/apex-web/lib/components/form/FormItem/FormItem.js';
import { AmountInput, MoneyInput } from '@t7x000/apex-web/lib/components/form/NumberInput/index.js';

const selectedInstrument = {
  Product1Symbol: 'BTC',
  Product2Symbol: 'USD',
};
const valueDP = 8;
const quantityDP = 2;

const BuyForm = ({ buy = true, formValues, reduxFormChange, handleSubmit }) => {
  const { anchoredField } = formValues;

  const price = formValues.limitPrice || 0;

  useEffect(() => {
    if (anchoredField === 'value') {
      const quantity = (formValues.value || 0) / price;
      if (
        typeof quantity === 'number' &&
        !Number.isNaN(quantity) &&
        Number.isFinite(quantity) &&
        quantity !== formValues.quantity
      ) {
        reduxFormChange('quantity', quantity);
      }
    }
  }, [anchoredField, price, formValues.value, formValues.quantity, reduxFormChange]);

  useEffect(() => {
    if (anchoredField === 'quantity') {
      const value = price * (formValues.quantity || 0);
      if (typeof value === 'number' && !Number.isNaN(value) && value !== formValues.value) {
        reduxFormChange('value', value);
        // handleOrderTotalChange(value);
      }
    }
  }, [
    anchoredField,
    price,
    formValues.quantity,
    formValues.value,
    reduxFormChange,
    // handleOrderTotalChange,
  ]);

  return (
    <div className="order-form__container">
      <form onSubmit={handleSubmit} className="form-fields">
        <RFormInputItem
          component={MoneyInput}
          name="limitPrice"
          placeholder="0"
          label={'Limit Price'}
          symbol={selectedInstrument && selectedInstrument.Product2Symbol}
          decimalPlaces={valueDP}
        />
        <RFormInputItem
          component={AmountInput}
          name="quantity"
          placeholder="0"
          label={buy ? 'Buy Amount' : 'Sell Amount'}
          symbol={selectedInstrument.Product1Symbol}
          decimalPlaces={quantityDP}
          onFocus={() => reduxFormChange('anchoredField', 'quantity')}
          isAprox={anchoredField === 'value'}
        />
        <RFormInputItem
          component={AmountInput}
          name="value"
          placeholder="0"
          label={'Order Total'}
          symbol={selectedInstrument.Product2Symbol}
          decimalPlaces={valueDP}
          onChange={() => console.log('handleOrderTotalChange')}
          onFocus={() => reduxFormChange('anchoredField', 'value')}
          isAprox={anchoredField === 'quantity'}
        />
      </form>
      <div className="form-data">
        <pre>{JSON.stringify(formValues, null, 2)}</pre>
      </div>
    </div>
  );
};

const emptyObject = {};

export const BuyFormContainer = reduxForm({
  form: 'buyFormDemo',
  enableReinitialize: false,
  destroyOnUnmount: false,
  initialValues: emptyObject,
  onSubmit: (payload) => {
    console.log('submit', payload);
  },
})(
  connect((state) => ({ formValues: state.form?.buyFormDemo?.values || emptyObject }), {
    reduxFormChange: (key, val) => change('buyFormDemo', key, val),
  })(BuyForm),
);
